/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskSupplementalInformationDetail
 */
export interface ExecRiskSupplementalInformationDetail {
    /**
     * 
     * @type {string}
     * @memberof ExecRiskSupplementalInformationDetail
     */
    FormAndLineReferenceDesc?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskSupplementalInformationDetail
     */
    ExplanationTxt?: string;
}

/**
 * Check if a given object implements the ExecRiskSupplementalInformationDetail interface.
 */
export function instanceOfExecRiskSupplementalInformationDetail(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskSupplementalInformationDetailFromJSON(json: any): ExecRiskSupplementalInformationDetail {
    return ExecRiskSupplementalInformationDetailFromJSONTyped(json, false);
}

export function ExecRiskSupplementalInformationDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskSupplementalInformationDetail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'FormAndLineReferenceDesc': !exists(json, 'FormAndLineReferenceDesc') ? undefined : json['FormAndLineReferenceDesc'],
        'ExplanationTxt': !exists(json, 'ExplanationTxt') ? undefined : json['ExplanationTxt'],
    };
}

export function ExecRiskSupplementalInformationDetailToJSON(value?: ExecRiskSupplementalInformationDetail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'FormAndLineReferenceDesc': value.FormAndLineReferenceDesc,
        'ExplanationTxt': value.ExplanationTxt,
    };
}

